import styles from "./transactionsummary.module.css";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TransactionSummary = ({ tenantData, expanded, handleChange }) => {

  return (<Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
      <div className={`${styles.FormAccoHead}`}>
        <p className={`${styles.FormAccoHeadTitlePro}`}>Transaction Summary</p>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      <div className={`${styles.cardUnderS}`}>
        <div className={`${styles.cardUnderSHead}`}>
          <div className={`${styles.HeadIcon}`}>
            <img src="/static/img/transaction-summary.png" alt="" />
          </div>
          <div className={`${styles.HeadCon}`}>
            <p className={`${styles.HeadConTitle}`}>Transaction Summary</p>
          </div>
        </div>
        <div className={`${styles.cardUnderSBody}`}>
          <div className={`${styles.SummeryList} ${styles.Green}`}>
            <span>Deposits:</span>
            {tenantData?.depositstr}
          </div>
          <div className={`${styles.SummeryList} ${styles.Red}`}>
            <span>Outstanding:</span>
            {tenantData?.balancestr}
          </div>
          <div className={`${styles.SummeryList} ${styles.Green}`}>
            <span>Payment Confidence:</span>
            {tenantData?.payment_confidence}%
          </div>
        </div>
      </div>
    </AccordionDetails>
  </Accordion>);
};

export default TransactionSummary;